export default __webpack_public_path__ + "static/media/SairaExtraCondensed-SemiBold.877e187d.ttf";